import {
  sentBlueprintRequest,
  fetchSendBlueprintRequestFailure,
  fetchgetTitleAndEscrowFailure,
  showSuccessToast,
  fetchDismissCardFailure,
  saveTitleAndEscrow,
  saveListingStage,
  getTitleAndEscrowStart,
  getListingStageStart,
  SubmitReqState,
} from "../TransactionDetailsPage/SideRight/TitleAndEscrow/actions/creators";
import { adaptBlueprintStage } from "../TransactionDetailsPage/SideRight/TitleAndEscrow/api/apiAdapters";

export const defaultState = {
  uuid: "",
  error: null,
  lastSubmitted: null,
  titleType: "",
  stage: null,
  isDismiss: false,
  isCardLoading: false,
  isStageLoading: false,
  submitReqState: { isloading: false, isSucceed: false, isFailed: false, failureMsg: "" },
  toastState: {
    show: false,
    msg: "",
  },
};

export const tdpTitleAndEscrowReducer = (state = defaultState, payload) => {
  switch (payload.type) {
    case sentBlueprintRequest().type:
      return {
        ...state,
        error: null,
      };
    case fetchSendBlueprintRequestFailure().type:
      return {
        ...state,
        error: payload.error,
      };
    case showSuccessToast().type: {
      return {
        ...state,
        error: null,
        toastState: payload.data,
      };
    }
    case fetchgetTitleAndEscrowFailure().type:
      return {
        ...state,
        isCardLoading: false,
        error: payload.error,
      };
    case fetchDismissCardFailure().type:
      return {
        ...state,
        error: payload.error,
      };

    case saveTitleAndEscrow().type:
      return {
        ...state,
        isCardLoading: false,
        isDismiss: payload.data?.meta?.dismissed_blueprint_info_card,
        lastSubmitted: payload.data?.blueprint_title?.submitted_at || "",
        titleType: payload.data?.blueprint_title?.title_type || "",
        error: null,
      };
    case saveListingStage().type:
      return {
        ...state,
        isStageLoading: false,
        stage: adaptBlueprintStage(payload.data),
      };
    case getTitleAndEscrowStart().type:
      return {
        ...state,
        isCardLoading: true,
      };
    case getListingStageStart().type:
      return {
        ...state,
        isStageLoading: true,
      };
    case SubmitReqState().type:
      return {
        ...state,
        submitReqState: payload.data,
      };
    default:
      return state;
  }
};

export default tdpTitleAndEscrowReducer;
